module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home"
  }, [_c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('x-input', {
    attrs: {
      "name": "username",
      "placeholder": "请输入姓名",
      "show-clear": _vm.showClear
    },
    model: {
      value: (_vm.userInfo.userName),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "userName", $$v)
      },
      expression: "userInfo.userName"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.3em",
      "width": "4em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("名 称")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "手机号",
      "show-clear": _vm.showClear,
      "name": "mobile",
      "placeholder": "请输入手机号码",
      "keyboard": "number"
    },
    model: {
      value: (_vm.userInfo.mobile),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "mobile", $$v)
      },
      expression: "userInfo.mobile"
    }
  }), _vm._v(" "), _c('x-input', {
    staticClass: "weui_vcode yzm",
    attrs: {
      "title": "验证码",
      "value": _vm.userInfo.vcode,
      "show-clear": _vm.showClear,
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.userInfo.code),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "code", $$v)
      },
      expression: "userInfo.code"
    }
  }, [_c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('x-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowBtn),
      expression: "isShowBtn"
    }],
    staticStyle: {
      "background": "rgba(44, 105, 242, 1)"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getVCode.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    获取验证码\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTimer),
      expression: "isShowTimer"
    }],
    staticStyle: {
      "height": "44px",
      "line-height": "44px"
    }
  }, [_vm._v(_vm._s(_vm.vcodeTime) + "s后重新发送")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bbd9942"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/xinxi.vue
// module id = 334
// module chunks = 0